import { Routes } from '@angular/router';

export const unsubscribeRoutes: Routes = [
  {
    path: 'email-unsubscribe',
    loadComponent: () => import('./components/unsubscribe/unsubscribe.component').then(c => c.UnsubscribeComponent)
  },
  {
    path: 'email-unsubscribe/success',
    loadComponent: () => import('./components/unsubscribe-confirmation/unsubscribe-confirmation.component').then(c => c.UnsubscribeConfirmationComponent)
  },
  {
    path: 'email-unsubscribe/moa-success',
    loadComponent: () => import('./components/unsubscribe-confirmation/moa-unsubscribe-confirmation/moa-unsubscribe-confirmation.component').then(c => c.MoaUnsubscribeConfirmationComponent)
  }
];
